import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';
import { sortTeamMembersAlphabetically } from '../helpers/sort';

const DEFAULT_STATE = Immutable([]);

export default function(state = DEFAULT_STATE, action = {}) {
  let array;
  switch (action.type) {
    case ActionTypes.TEAM_MEMBER_CREATED:
      array = Immutable.asMutable(state.concat([action.teamMember]));
      sortTeamMembersAlphabetically(array);
      return Immutable(array);
    case ActionTypes.TEAM_MEMBER_DELETED:
      return Immutable.flatMap(state, value => {
        if (
          action.teamMember.email === value.email ||
          action.teamMember.id === value.id
        ) {
          return [];
        }
        return value;
      });
    case ActionTypes.TEAM_MEMBER_UPDATED:
      array = Immutable.flatMap(state, value => {
        if (
          action.teamMember.email === value.email ||
          action.teamMember.id === value.id
        ) {
          return action.teamMember;
        }
        return value;
      }).asMutable();
      sortTeamMembersAlphabetically(array);
      return Immutable(array);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/teamMembers.js